import { UserRoles } from 'services/api';
import { User } from 'types';

export default function isPhoneRequired(user: User, employeeRole: UserRoles) {
  return !user.company.require_account_linking ||
    employeeRole === UserRoles.Manager
    ? true
    : false;
}
